import { css } from 'lit';
export const carouselItemStyles = css `
    .hlx-carousel-item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        max-height: 100%;
        pointer-events: none;
    }

    ::slotted(img) {
        width: 100%;
        object-fit: cover;
    }
`;
//# sourceMappingURL=carousel-item.styles.js.map